import { z } from "zod";

export default function validCPF(value) {
  const isString = typeof value === "string";
  const isValid = /^\d{11}$/.test(value);

  if (!isString) return false;
  if (!isValid) return false;
  if (value.length !== 11) return false;

  const cpfNumbers = value.split("").map(Number);

  const items = [...new Set(cpfNumbers)];
  if (items.length === 1) return false;

  const digits = cpfNumbers.slice(9);
  const isDigit0Valid = rest(10, cpfNumbers) === digits[0];
  const isDigit1Valid = rest(11, cpfNumbers) === digits[1];

  return isDigit0Valid && isDigit1Valid;
}

const rest = (count, numbers) => {
  return (
    ((numbers
      .slice(0, count - 12)
      .reduce((acc, curr, index) => acc + curr * (count - index), 0) *
      10) %
      11) %
    10
  );
};

export const baseSchema = z.object({
  name: z
    .string({ message: "error.field_required" })
    .min(1, { message: "error.field_required" }),
  document: z
    .string({ message: "error.field_required" })
    .min(1, { message: "error.field_required" })
    .refine(
      (value) => {
        const sanitizedValue = value
          .replace(/\./g, "")
          .replace(/-/g, "")
          .toUpperCase();

        if (/^\d{11}$/.test(sanitizedValue)) {
          return validCPF(sanitizedValue);
        }

        if (/^[A-Z0-9]{6,12}$/.test(sanitizedValue)) {
          return true;
        }

        return false;
      },
      {
        message: "error.invalid_document",
      }
    ),
  ddi: z
    .string({ message: "error.field_required" })
    .min(1, { message: "error.field_required" }),
  phone: z
    .string({ message: "error.field_required" })
    .min(1, { message: "error.field_required" }),
});

export function formatPhoneForSubmit(ddi, phone) {
  const ddiDigits = ddi.replace(/\D/g, "");
  const phoneDigits = phone.replace(/\D/g, "");
  return `+${ddiDigits}${phoneDigits}`;
}

export function formatFiscalId(value) {
  if (/[a-zA-Z]/.test(value)) {
    return value;
  }

  const onlyNumbers = value.replace(/\D/g, "");

  if (onlyNumbers) {
    const limitedNumbers = onlyNumbers.slice(0, 11);

    const formatted = limitedNumbers
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    return formatted;
  }

  return value;
}

export const formatCurrency = ({ value, locale, currency }) => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(isNaN(value) ? 0 : value);
};

export function transformStringValueToNumber({ value }) {
  return Number(value.replace(",", "."));
}
